module.exports = __webpack_public_path__ + "img/slide4.d6c4390b.jpg";